import { ApiInterceptorInterceptor } from './../../interceptor/api-interceptor.interceptor';
import { Injectable, Inject } from '@angular/core';
import { AppSettings } from './app-settings';
import { CookieService } from 'ngx-cookie-service';
import { WINDOW } from 'src/app/window-provider';
import { ApiService } from '../api/api.service';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from 'src/app/auth.service';

@Injectable({
  providedIn: 'root'
})

export class AppSettingsService {

  SETTINGS_KEY = "ePosConfig";
  GetSession :string;

  private currencySubject = new BehaviorSubject<any>(this.getInitialCurrency());
  currency$ = this.currencySubject.asObservable();

  
  private localeSubject = new BehaviorSubject<any>(this.getInitialLocale());
  locale$ = this.localeSubject.asObservable();

  constructor(@Inject(WINDOW) private window: Window, private cookieService : CookieService,private apiService : ApiService, private authService: AuthService) { }

  GetApiSettings()
  {
    this.GetSession = localStorage.getItem('userName')
    //let parsedData = JSON.parse(this.GetSession);

    let settings : AppSettings = new AppSettings();
    settings.lastUsedToken = this.cookieService.get("ePosLastToken");
    settings.userName = this.GetSession;
    settings.userGroup = this.cookieService.get("ePosUserGroup");
    
    //ApiInterceptorInterceptor.token = settings.lastUsedToken;   
    return settings;
  }

  SaveApiSettings(settings: AppSettings)
  {
    let expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + 1);
    
    this.cookieService.set("ePosLastToken", settings.lastUsedToken, 
    { domain : this.window.location.hostname, path : '/', expires: expireDate, sameSite: 'Lax' });
    this.cookieService.set("ePosUsername", settings.userName, 
    { domain : this.window.location.hostname, path : '/', expires: expireDate, sameSite: 'Lax' });
    this.cookieService.set("ePosUserGroup", settings.userGroup, 
    { domain : this.window.location.hostname, path : '/', expires: expireDate, sameSite: 'Lax' });
  }
  
  DeleteApiSettings()
  {
    this.cookieService.delete('ePosLastToken', '/');
    this.cookieService.delete('ePosUsername', '/');
    this.cookieService.delete('ePosUserGroup', '/');
    ApiInterceptorInterceptor.token = '';
  }

  SaveCookieSettings(key : string, values : string[])
  {
    let expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + 7);

    let value : string = "";

    for (let i = 0; i < values.length; ++i)
    {
      value += values[i];

      if (i != values.length - 1)
      {
        value += ",";
      }
    }
    
    this.cookieService.set(key, value, 
    { domain : this.window.location.hostname, path : '/', expires: expireDate, sameSite: 'Lax' });
  }

  GetCookieSettings(key : string)
  {
    let usernames = this.cookieService.get(key).split(',');

    if (usernames.length == 0)
    {
      usernames = null;
    }
    else if (usernames.length == 1 && usernames[0] == '')
    {
      usernames = null;
    }
    return usernames;
  }

// Currency

  get locale(): string {
    return this.localeSubject.value;
  }

  private getInitialCurrency() {
    const data = localStorage.getItem('default_currency');
    return data ? JSON.parse(data) : { code: '', symbol: '', locale: 'en-US' };
  }

  private getInitialLocale(){
    const data = localStorage.getItem('default_currency');
    let tempLocale = "en-US";
    if (data){
      let parsed = JSON.parse(data);
      tempLocale = parsed?.locale;

    }
    return tempLocale;

  }

  loadDefaultCurrency(): Promise<void> {
    
    const token = localStorage.getItem('access_token');
    if (token){
      return this.apiService.getDefaultCurrencySetting().toPromise()
        .then((res: any) => {
          if (res.data && res.data.length > 0) {
            const currencyObj = {
              code: res.data[0].M_BASE_CURRENCY_CODE,
              symbol: res.data[0].M_SYMBOL,
              locale: res.data[0].M_BASE_CURRENCY_CODE === "IDR" ? "id-ID" : "en-US"
            };
            localStorage.setItem('default_currency', JSON.stringify(currencyObj));
            
            // 3. Push the new value to all subscribers!
            this.currencySubject.next(currencyObj);
            this.localeSubject.next(currencyObj.locale)
          } else {
            localStorage.removeItem('default_currency');
          }
        });

    }
    else {
      return null;
    }
    
  }

}
